import useModalWithContext from '../../../../hooks/useModalWithContext';

export type ManagePackageLabelsState = {
  revision?: string;
  title?: string;
};
export const useManagePackageLabelsModal = () => {
  return useModalWithContext<ManagePackageLabelsState>({});
};
